import { MapPinIcon, XCircleIcon } from '@heroicons/react/24/solid';
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { useEffect, useState } from 'react';
import { NumericFormat as NumberFormat } from 'react-number-format';
import { Link } from 'react-router';
import { getAddressDecode } from '@/api/misc';
import { CurrencyFormatDisplay } from '@/components/UI/NumberFormatDisplay/CurrencyFormatDisplay';
import type ProjectDetail from '../../../../types/ProjectwithGeo';
import type { DashboardProjectByLocationInterface } from '../../../Widgets/ProjectLocationWidget';
import GoogleMap from '..';

const MapGoogle = ({ projectList }: { projectList: DashboardProjectByLocationInterface[] }) => {
  const [load, setload] = useState(false);
  const [selectedMarker, setSelectedMarker] = useState<number>(0);
  const [geoLocationArray, setGeoLocationArray] = useState<any[]>([]);

  useEffect(() => {
    const geoArray: any = [];
    projectList.forEach((project: DashboardProjectByLocationInterface, i: number) => {
      const fullAddress = [project.address, project.city, project.state, project.zipCode].filter(Boolean).join(',');

      getAddressDecode(fullAddress).then(
        (response) => {
          const { lat, lng } = response.data;
          geoArray.push({
            ...project,
            coordinates: { lat, lng },
            isDataVisible: false,
            include: true,
          });
          if (i + 1 === projectList.length) {
            setload(true);
          }
        },
        (_error) => {
          geoArray.push({
            ...project,
            coordinates: { lat: 28.37373, lng: 29.3838883 },
            isDataVisible: false,
            include: false,
          });
          if (i + 1 === projectList.length) {
            setload(true);
          }
        }
      );
    });
    geoArray.filter((geo: any) => geo.include === true);
    setGeoLocationArray(geoArray);
  }, [projectList]);

  const handlePinClick = (project: ProjectDetail) => {
    setGeoLocationArray((prevState) => {
      return prevState.map((ps) => {
        if (ps.id === project.id) {
          return { ...ps, isDataVisible: !ps.isDataVisible };
        } else {
          return { ...ps, isDataVisible: false };
        }
      });
    });
    setSelectedMarker(project.id);
  };

  return (
    <>
      {load && geoLocationArray.length > 0 && (
        <GoogleMap
          defaultCenter={{
            lat: geoLocationArray[0].coordinates.lat,
            lng: geoLocationArray[0].coordinates.lng,
          }}
          defaultZoom={10}
        >
          {geoLocationArray?.map((project: any) => {
            return (
              <AdvancedMarker
                key={project.id}
                position={{
                  lat: project.coordinates.lat,
                  lng: project.coordinates.lng,
                }}
              >
                <div onClick={() => handlePinClick(project)} className='relative'>
                  {project?.isDataVisible && (
                    <div className='bg-white border rounded absolute p-3 bottom-4 left-5 w-56'>
                      <XCircleIcon className='h-4 w-4 absolute right-1 top-1 text-neutralColor-normal' />
                      <Link to={`/app/rover/partner-proposals/${project?.id}`}>
                        <p className='font-semibold text-primaryColor-normal underline'>{project?.name}</p>
                      </Link>
                      <p className='text-xs'>{project?.address}</p>
                      <p className='text-xs'>
                        {project?.city}, {project?.state}, {project?.postalCode}
                      </p>

                      {project?.sources && (
                        <div className='mt-2 text-sm flex justify-between gap-2'>
                          <span>Development Cost</span>
                          <span className='font-semibold'>
                            <CurrencyFormatDisplay value={project?.sources} prefix='$' />
                          </span>
                        </div>
                      )}

                      {project?.squareFeet && (
                        <div className='mt-2 text-sm flex justify-between gap-2'>
                          <span>Sq.Ft</span>
                          <span className='font-semibold'>
                            <NumberFormat value={project?.squareFeet} displayType='text' thousandSeparator={true} /> Sq.Ft
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                  <MapPinIcon className={selectedMarker === project.id ? 'h-8 w-8 text-black' : 'h-8 w-8 text-red-500 '} />
                </div>
              </AdvancedMarker>
            );
          })}
        </GoogleMap>
      )}
    </>
  );
};

export default MapGoogle;
